<div
  *ngIf="{
    violations: violations$ | async
  } as State"
  class="password-init"
>
  <authentication-wrapper>
    <article class="password-init__content-wrapper">
      <div class="form__header">
        <h2 class="form__title">Initialisation du mot de passe</h2>
      </div>

      <form [formGroup]="form">
        <div class="form__header">
          <p class="form__description">Veuillez définir votre mot de passe</p>
        </div>
        <section>
          <div class="form-field__wrapper form-field-auth-page">
            <label for="" class="form-field__label">Ancien mot de passe</label>
            <mat-form-field class="form-field__input" appearance="outline">
              <input
                #passwordInput
                formControlName="password"
                matInput
                name="password"
                type="password"
                placeholder="Doit être au moins 6 caractères"
              />

              <button
                mat-icon-button
                matSuffix
                (click)="
                  passwordInput.type === 'password'
                    ? (passwordInput.type = 'text')
                    : (passwordInput.type = 'password')
                "
              >
                <mat-icon>{{
                  passwordInput.type === 'password'
                    ? 'visibility_off'
                    : 'visibility'
                }}</mat-icon>
              </button>
              <mat-error *ngIf="form.get('password')?.hasError('required')">
                Cette valeur est <strong>requise</strong>
              </mat-error>
              <mat-error
                *ngIf="form.get('password')?.getError('httpError') as httpError"
              >
                <strong>{{ httpError }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field__wrapper form-field-auth-page">
            <label for="" class="form-field__label">Nouveau mot de passe</label>
            <mat-form-field class="form-field__input" appearance="outline">
              <input
                #newPasswordInput
                formControlName="newPassword"
                matInput
                name="newPassword"
                type="newPassword"
                placeholder="Doit être au moins 6 caractères"
              />

              <button
                mat-icon-button
                matSuffix
                (click)="
                  newPasswordInput.type === 'password'
                    ? (newPasswordInput.type = 'text')
                    : (newPasswordInput.type = 'password')
                "
              >
                <mat-icon>{{
                  newPasswordInput.type === 'password'
                    ? 'visibility_off'
                    : 'visibility'
                }}</mat-icon>
              </button>
              <mat-error *ngIf="form.get('newPassword')?.hasError('required')">
                Cette valeur est <strong>requise</strong>
              </mat-error>
              <mat-error
                *ngIf="
                  form.get('newPassword')?.getError('httpError') as httpError
                "
              >
                <strong>{{ httpError }}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <button
            (click)="setPassword()"
            [attr.loading]="isLoading"
            [disabled]="isLoading || form.invalid"
            type="button"
            class="btn btn--full btn--primary"
          >
            Définir mot de passe
          </button>
        </section>
      </form>
    </article>
  </authentication-wrapper>
</div>
